import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { collection, deleteField, getFirestore, serverTimestamp } from "firebase/firestore";
import { getStorage, ref } from "firebase/storage";
var DEV = {
    apiKey: "AIzaSyDFV4Pm43eQXbFUrayG9Dj_7ddEBzQ9Gd4",
    authDomain: "csound-ide-dev.firebaseapp.com",
    databaseURL: "https://csound-ide-dev.firebaseio.com",
    projectId: "csound-ide-dev",
    storageBucket: "csound-ide-dev.appspot.com",
    messagingSenderId: "449370062532",
    appId: "1:449370062532:web:a9a2802fe150e69c6e1391"
};
var PROD = {
    apiKey: "AIzaSyCbwSqIRwrsmioXL7b0yqrHJnOcNNqWN9E",
    authDomain: "csound-ide.firebaseapp.com",
    databaseURL: "https://csound-ide.firebaseio.com",
    projectId: "csound-ide",
    storageBucket: "csound-ide.appspot.com",
    messagingSenderId: "1089526309602"
};
var firebaseApp;
// INITIALIZE FIREBASE WITH SETTINGS
if (!firebaseApp) {
    var target;
    if (process.env.REACT_APP_DATABASE === "DEV") {
        target = DEV;
    }
    else if (process.env.REACT_APP_DATABASE === "PROD") {
        target = PROD;
    }
    // firebase.settings();
    firebaseApp = initializeApp(target);
}
// CREATE REFERENCES FOR USE BY APP CODE
export var database = getFirestore();
export var projectLastModified = collection(database, "projectLastModified");
export var projects = collection(database, "projects");
export var projectsCount = collection(database, "projectsCount");
export var profiles = collection(database, "profiles");
export var followers = collection(database, "followers");
export var following = collection(database, "following");
export var manual = collection(database, "manual");
export var usernames = collection(database, "usernames");
export var targets = collection(database, "targets");
export var tags = collection(database, "tags");
export var stars = collection(database, "stars");
export var profileStars = collection(database, "profileStars");
export var projectFiles = collection(database, "projectFiles");
export var storageReference = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(path) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1)
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return ref(getStorage(firebaseApp), path);
                    case 2:
                        return _context.abrupt("return", _context.sent);
                    case 3:
                    case "end":
                        return _context.stop();
                }
        }, _callee);
    }));
    return function storageReference(_x) {
        return _ref.apply(this, arguments);
    };
}();
// OTHER
export var getCurrentUserPromise = function getCurrentUserPromise() {
    return new Promise(function (resolve) {
        var unsubscribe = onAuthStateChanged(getAuth(), function (user) {
            resolve(user);
            unsubscribe();
        });
    });
};
export var getFirebaseTimestamp = serverTimestamp;
export { Timestamp } from "firebase/firestore";
export var fieldDelete = function fieldDelete() {
    return deleteField();
};
